/** Public product identity. Service endpoints and persisted IDs are configured separately. */
export const PRODUCT_NAME = 'Atlas';
export const PRODUCT_OWNER = 'Solidum Invest';
export const PRODUCT_WEBSITE_URL = 'https://www.solidum-invest.de';
export const PRODUCT_SUPPORT_EMAIL = 'atlas@solidum-invest.de';
export const PRODUCT_SUPPORT_URL = `mailto:${PRODUCT_SUPPORT_EMAIL}`;

/** Only an explicitly published installer on our application host is offered. */
export function runtimeInstallerBase(
  value: string | undefined
): string | undefined {
  if (
    !value ||
    !/^https:\/\/atlas\.solidum-invest\.de(?:\/[a-zA-Z0-9._~/-]*)?$/.test(value)
  ) {
    return undefined;
  }
  return value.replace(/\/+$/, '');
}

/** Legal documents must be explicitly published on an operator-owned HTTPS host.
 * This validates the destination, not the document's availability or approval.
 */
export function productLegalUrl(value: string | undefined): string | undefined {
  if (!value || !value.startsWith('https://') || /[\s\\]/.test(value)) {
    return undefined;
  }
  // Reject parser normalization of encoded authorities and empty credentials.
  const authority = value.slice('https://'.length).split(/[/?#]/, 1)[0];
  if (!authority || /[%@:]/.test(authority)) return undefined;
  try {
    const url = new URL(value);
    const ownerHost = new URL(PRODUCT_WEBSITE_URL).hostname.replace(
      /^www\./,
      ''
    );
    if (
      (url.hostname !== ownerHost && !url.hostname.endsWith(`.${ownerHost}`)) ||
      url.pathname === '/' ||
      url.username ||
      url.password ||
      url.port ||
      url.search ||
      /%(?![0-9a-f]{2})/i.test(value)
    ) {
      return undefined;
    }
    return url.href;
  } catch {
    return undefined;
  }
}

export const PRODUCT_TERMS_URL = productLegalUrl(
  import.meta.env?.VITE_ATLAS_TERMS_URL
);
export const PRODUCT_PRIVACY_URL = productLegalUrl(
  import.meta.env?.VITE_ATLAS_PRIVACY_URL
);
export const PRODUCT_IMPRINT_URL = productLegalUrl(
  import.meta.env?.VITE_ATLAS_IMPRINT_URL
);
